import React from 'react'
import type { Theme, AccordionSummaryProps } from '@material-ui/core'
import { withStyles, createStyles, AccordionSummary } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      ...theme.typography.overline,
      padding: 0,
      minHeight: 38,
      maxHeight: 38,
      '&.Mui-expanded': {
        minHeight: 0
      }
    },
    content: {
      '&.Mui-expanded': {
        marginTop: 12,
        marginBottom: 12
      }
    },
    disabled: {
      '&.Mui-disabled': {
        backgroundColor: 'transparent',
        opacity: 1,
        paddingRight: 34
      }
    },
    expandIcon: {
      color: theme.palette.grey[600]
    }
  })

export interface ExpansionPanelSummaryProps extends Omit<AccordionSummaryProps, 'classes'> {}

function ExpansionPanelSummary(props: ExpansionPanelSummaryProps) {
  const expandIcon = props.expandIcon ? props.expandIcon : <ExpandMoreIcon />
  return <AccordionSummary {...props} expandIcon={props.disabled ? null : expandIcon} />
}

export default withStyles(styles)(ExpansionPanelSummary)
